const callCallbackWithDelayUtil = (callback: any, timeout = 300): any =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(callback)
    }, timeout)
  })

export default callCallbackWithDelayUtil
